import React from 'react';
import c from './userInitials.module.scss';

const UserInitialsItem = ({
  onClick,
  text,
  icon,
  rightIcon,
  href,
  index,
  handleClose,
  handleKeyDown,
  handleFocus,
  innerRef,
  isMobile,
  id,
}) => {
  const handleOnClick = () => {
    onClick && onClick();
    handleClose && handleClose();
  };
  return (
    <>
      {href ? (
        <a
          id={id}
          className={c.userInitialsItem}
          ref={innerRef}
          href={href}
          target="_blank"
          rel="noreferrer"
          role={!isMobile ? 'menuitem' : null}
          aria-label={`${text}. Opens in a new window`}
          onFocus={() => handleFocus && handleFocus(index)}
          onKeyDown={handleKeyDown}
        >
          <span>{icon}</span>
          <span className={c.item}>{text}</span>
        </a>
      ) : (
        <button
          id={id}
          type="button"
          onClick={handleOnClick}
          onKeyDown={handleKeyDown}
          onFocus={() => handleFocus && handleFocus(index)}
          className={
            text === 'Log out'
              ? [c.userInitialsItem, c.logout].join(' ')
              : c.userInitialsItem
          }
          ref={innerRef}
          role={!isMobile ? 'menuitem' : null}
        >
          <span>{icon}</span>
          <span className={c.item}>{text}</span>
          {rightIcon && <span>{rightIcon}</span>}
        </button>
      )}
    </>
  );
};

export default UserInitialsItem;
